export const podcastEn = {
  dashboard: {
    title: "Podcast Studio (Basic)",
    description: "Plan seasons, draft episodes, and manage scripts from one workspace.",
    searchLabel: "Search across series & episodes",
    searchPlaceholder: "Search by series name, episode title, script text…",
    newSeries: "New Series",
    cancel: "Cancel",
    createSeries: "Create series",
    loadingSeries: "Loading your podcast series...",
    emptySeries: "No podcast series yet. Create one to start organizing your episodes.",
    paginationLabel: "Podcast series pagination",
    perPage: "Per page",
    pageOf: "Showing {range} of {total} series",
    errors: {
      loadFailed: "Unable to load podcast series. Please refresh to try again.",
      searchFailed: "Search failed.",
      createFailed: "Unable to create podcast series right now.",
    },
    form: {
      nameLabel: "Name",
      descriptionLabel: "Description",
      seasonLabel: "Season number",
      episodesLabel: "Planned episodes",
      templateLabel: "Start from template",
      descriptionPlaceholder: "High-level summary of the season focus.",
      templatePlaceholder: "Blank series",
    },
  },
  series: {
    actions: {
      backToPodcast: "Back to Podcast",
      settings: "Settings",
      importEpisode: "Import Episode",
      addEpisode: "Add Episode",
    },
    form: {
      title: "Add episode",
      fieldTitle: "Title",
      fieldSummary: "Summary",
      templateLabel: "Start from template",
      create: "Create episode",
      cancel: "Cancel",
    },
    messages: {
      importSuccess: "Episode bundle added to the board.",
      importFailed: "Unable to import episode bundle.",
      selectFile: "Cannot import without a series.",
    },
    cards: {
      loading: "Loading episodes...",
      error: "Unable to load episodes. Please refresh and try again.",
      empty: "No episodes yet. Use “Add Episode” to start building this season.",
    },
  },
  episode: {
    tabs: {
      script: "Script",
      review: "Review",
      audio: "Audio",
      clips: "Clips",
      publish: "Publish",
      ariaLabel: "Episode workspace tabs",
    },
    actions: {
      autoBuild: "Auto Build Episode",
      autoBuildLoading: "Auto-building…",
      keyboardShortcuts: "Keyboard shortcuts",
      export: "Export episode (JSON)",
      saveTitle: "Save title",
      generateDraft: "Generate draft script",
      generateDraftLoading: "Generating...",
      saveScript: "Save script",
      generateShowNotes: "Generate show notes",
      generateShowNotesLoading: "Generating...",
      saveNotes: "Save notes",
      addGuest: "Add guest",
      removeGuest: "Remove",
      acknowledgeReview: "Mark review as addressed",
      sendToReview: "Send to review",
      sendToReviewLoading: "Sending...",
      saveVoice: "Save",
      renderAudio: "Render Draft Audio",
      applyTranslation: "Replace script with translation",
      clearTranslation: "Clear translation",
      generateBlog: "Generate Blog Version",
      generateBlogLoading: "Generating...",
      sendBlog: "Send to Blog Agent",
      sendBlogLoading: "Routing...",
      summarizeContext: "Summarize Context",
      outlineFromContext: "Generate Outline",
      summarizeLoading: "Summarizing...",
      outlineLoading: "Building outline...",
      addAsset: "Add asset",
      saveAsset: "Save asset",
      deleteAsset: "Delete",
      paginatePrevious: "Previous assets",
      paginateNext: "Next assets",
    },
    tooltips: {
      tabs: "Episode workspace tabs",
      reviewToggle: "Toggle review notifications",
    },
    statuses: {
      analyticsLoading: "Calculating analytics…",
      analyticsEmpty: "Analytics will appear once this episode has a script.",
    },
  },
  publish: {
    metadataTitle: "Metadata",
    clipsTitle: "Clips & highlights (Pro)",
    publishWorkspace: "Publishing workspace",
    generateMetadata: "Generate from AI",
    extractClips: "Extract clips",
    publishNow: "Publish Now",
    schedulingSoon: "Scheduling coming soon",
  },
  templates: {
    title: "Podcast Templates",
    backToPodcast: "← Back to Podcast",
    createTitle: "Create template",
    save: "Save template",
    delete: "Delete",
  },
};
